import { render, staticRenderFns } from "./DashBlock.vue?vue&type=template&id=1e315850&scoped=true"
import script from "./DashBlock.vue?vue&type=script&lang=js"
export * from "./DashBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e315850",
  null
  
)

export default component.exports